import { Guide, Code, Database } from "#types";

export const getMenuList = (db: Database, isAffiliate: boolean) => {
    if (db === Database.ZIM) {
        return ["users", "b2b"]
    }
    if (db !== Database.GD || isAffiliate) {
        return ["users"]
    }
    return ["users", "reports", "livechat", "faq", "blacklist", "notifications", "locale", 'tutorials', "esims"]
}

export const userTableHeaders: string[] = [
    "Email",
    "First Name",
    "Last Name",
    "Location",
    "Joined Using",
    "Device OS",
    "Has eSIM"
]

export const userTableHeadersV3: string[] = [
    "Email",
    "ID",
    "Sub",
    "First Name",
    "Last Name",
    "Location",
]

export const esimTableHeaders: string[] = [
    "ICCID",
    "Provider",
    "Email",
    "MSIDN",
    "Status",
]

export const b2bAccountTableHeaders: string[] = [
    "Nano ID",
    "Name",
    "Type",
    "Owner",
]

export const conversationTableHeaders: string[] = [
    "Email",
    "Title",
    "Problem",
    "Created At"
]

export const blacklistedUsersTableHeaders: string[] = [
    "Email",
    "Device ID",
    "Delete?"
]

export const reportTableHeaders: string[] = [
    "Email",
    "Date",
    "Type",
    "Description",
    "Message",
    "Images",
    "Is Open?"
]

export const plansTableHeaders: string[] = [
    "ID",
    "Name",
    "Provider",
    "Location",
    "Data",
    "Duration"
]

export const promotionTableHeaders: string[] = [
    "Code",
    "No. Users",
    "Is Active?",
    "Discount",
    "Type",
    "Scope",
    "One Off Used?",
    "Remaining Uses",
    "Valid From",
    "Valid To"
]

export const rewardsTableHeaders: string[] = [
    "Company Name",
    "Title",
    "Subtitle",
    "Description",
    "Reward Code",
    "Active",
    "Target Flag Codes",
    "Priority",
    // "Instructions",
    // "Additional Info",
    "Valid From",
    "Valid To",
]

export const notificationCodesTableHeaders: string[] = [
    "User Attribute",
    "Code"
]

export const notificationCodes: Code[] = [
    {
        label: 'Customer First Name',
        code: '{firstName}'
    },
    {
        label: 'Customer Last Name',
        code: '{lastName}'
    },
    {
        label: 'Customer Current Location',
        code: '{currentLocation}'
    },
    {
        label: 'Customer Email',
        code: '{email}'
    }
]

export const constants = {
    accessToken: '_accessToken',
    refreshToken: '_refreshToken',
    targetEnv: '_targetEnv',
    targetDb: '_targetDb'
}

export const reportPerPageNumberOptions = [
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 20, label: '20' },
];

export const genericPerPageNumberOptions = [
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 50, label: '50' },
];

export const guideToCreateAPromotion: Guide[] = [
    { title: "Title", description: "Heading for the promotion when the customer applies the promotion in the app" },
    { title: "Description", description: "Message displayed to the customer if they click on more information about the promotion" },
    { title: "Code", description: "Used by the customer in the app to apply the promotion, must be 8 digits or less" },
    { title: "Amount", description: "In percentage the discount (only type the number)" },
    { title: "Valid From/To", description: "Dates the promotion will be available for the customers to use, by default the valid from is the time now and valid to is the time tomorrow. If you change these values, the time date will be midnight of the start of the selected date (example: 17/06/2023 00:00:00)" },
    { title: "Background URL", description: "The image that displays behind the promotion in the app" },
    { title: "Target Emails", description: "(optional) Only customers with these emails can use the promotion, should be inputted by typing the emails separated by a commar and space" },
    {
        title: "Type", description: `Changes the behaviour of the promtion as it is used by the customer: \n
        NORMAL - can be used by any customer an unlimited amount of times \n
        PROMOTION - applied to the entire app during a special event (example: black Friday) \n
        LIMITED_USE - number of times the code can be used before expiring. A targeted email and a value for number of uses remaining is needed to create this type. For unlimited use, enter 999 for number of uses remaining. \n
        EVENT - does not have a use for now`
    },
    { title: "Number of uses remaining", description: "How many times the promotion can be used before expiring (only relevant with limited use type promotions)" },
    {
        title: "Scope", description: `Limits the type of customer that can use the promotion: \n
        GLOBAL - any customer can use the code \n
        GROUP - has no use for now 
        EXCLUSIVE - only new customers can use the code \n`
    },
    { title: "*", description: "any field with a * is required for the promotion creation" },
]

export const guideToCreateAReward: Guide[] = [
    { title: "Company Name", description: "The display name of the company offering the reward" },
    { title: "Title", description: "A breif summary of the offer" },
    { title: "Subtitle", description: "Further information for the offer" },
    { title: "Description", description: "Full description of the offer" },
    { title: "Reward Code", description: "Three letter code that identifies the reward, should be the same value for the reward in all languages" },
    { title: "Priority", description: "Number that instructs the order that the rewards are displayed in the app" },
    { title: "Language", description: "Only customers with this preferred language will see the reward" },
    { title: "Instructions", description: `Title: (optional) An introduction into the instruction.\n
        List type: determines whether the values will be listed with a bullet points or numbered list.\n
        Value: each value will display as a new bullet point or number in the list`
    },
    { title: "Additional Information", description: "Same as instructions, but with information relevant to the reward that is not directly how to use the reward." },
    { title: "Active", description: "True or false - is the reward currently active" },
    { title: "Target Flag Codes", description: "A list of 2 letter flag codes that will determine the customers in which countries will see the reward. Leave blank for all" },
    { title: "Reward Background URL", description: "The URL of logo associated with the company offering the reward" },
    { title: "Includes Partner Voucher", description: "True or false - does the reward require a voucher" },
    { title: "Valid From/To", description: "Dates that describe the start and end of the reward" },
]
